export default __webpack_public_path__ + "static/media/mexican_knappett-webfont.68a1d7e3.woff2";